module.exports = __webpack_public_path__ + "img/product-dashboard.5d615e62.svg";